import { createActions, createReducer } from 'reduxsauce'
import BonusPointsService from './../../services/bonus-points.service'

const initialState = {
	roundTrip: 0
}

const setRoundTripPoints = (state = initialState, { roundTrip }) => {
	return {
		...state,
		roundTrip
	}
}

const loadRoundTripPoints = () => dispatch => {
	return BonusPointsService.getBonusPointsForRoundTrip().then(({ data }) =>
		dispatch(Creators.setRoundTripPoints(data))
	)
}

export const { Types, Creators } = createActions(
	{
		loadRoundTripPoints,
		setRoundTripPoints: ['roundTrip']
	},
	{ prefix: 'bonus-points/' }
)

export default createReducer(initialState, {
	[Types.SET_ROUND_TRIP_POINTS]: setRoundTripPoints
})
